'use strict';

import Styles from './less/core.less';
import Factory from 'generic.factory';

let factoryInstance = new Factory({
    className: 'js-header-top',
    ensure: (resolve, callAfter) => {
        let instance = require('./js/generic.header-top');
        resolve(callAfter(instance.default || instance));
    }
});

factoryInstance.init();

export default factoryInstance;



// WEBPACK FOOTER //
// ./app/components/header/main.js